<template>
  <page-container :title="pageTitle" :breadcrumb="breadcrumb">
    <div class="box-container" style="margin-top: 10px;">
      <div class="box-container-inner">
        <div class="simple-query">
          <a-form-model ref="queryForm" :model="queryParams" layout="inline" class="query-form">
            <a-form-model-item label="待整改单位" prop="depwaitrect">
              <a-input v-model.trim="queryParams.depwaitrect" placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="待整改电梯" prop="liftwaitrect">
              <a-input v-model.trim="queryParams.liftwaitrect" placeholder="请输入"></a-input>
            </a-form-model-item>
            <div class="query-btns">
              <a-button @click="resetQueryParams">重置</a-button>
              <a-button type="primary" class="after-btn" @click="getTableData(true)">查询</a-button>
              <a-button type="link" @click="showAdvanced=!showAdvanced">展开<a-icon :type="showAdvanced?'up':'down'"></a-icon></a-button>
            </div>
          </a-form-model>
        </div>
        <div v-show="showAdvanced" class="advanced-query">
          <a-form-model ref="advancedForm" :model="queryParams" layout="inline" class="query-form">
            <a-form-model-item label="问题整改发起人" prop="initiator">
              <a-input v-model.trim="queryParams.initiator" placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="受理人" prop="acceptor">
              <a-input v-model.trim="queryParams.acceptor" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>
    <div class="box-container" style="margin-top: 10px;">
      <div class="box-container-inner">
        <div class="table-header">
          <h3 class="table-title">{{pageTitle}}</h3>
          <div class="table-btns">
            <a-button type="primary" style="margin-left: 8px;" @click="showModal('add')"><a-icon type="plus"></a-icon>新建</a-button>
            <a-icon type="redo" class="after-btn table-refresh" @click="getTableData(true)"></a-icon>
          </div>
        </div>
        <a-table :columns="tableColumns" :data-source="tableData" row-key="abarbeitungid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">
          <span slot="recttime" slot-scope="value,record">
            <span>{{value ? moment(value, 'YYYYMMDD').format('YYYY-MM-DD') : ''}}</span>
          </span>
          <span slot="isreply" slot-scope="value">
            <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'是':'否'}}</a-tag>
          </span>
          <span slot="approved" slot-scope="value">
            <a-tag :color="value=='1'?'green':'red'">{{value=='1'?'已整改':'未整改'}}</a-tag>
          </span>
          <span slot="operation" slot-scope="value, record">
            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <a-icon type="menu"/>
              </a>
              <a-menu slot="overlay" @click="operationClick">
                <a-menu-item :key="'detail-'+record.abarbeitungid">详情</a-menu-item>
                <a-menu-item :key="'delete-'+record.abarbeitungid">修改</a-menu-item>
                <a-menu-item :key="'export-'+record.abarbeitungid">导出</a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
        <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" @showSizeChange="onShowSizeChange" :show-total="(total, range) => `共${total}条`" style="margin-top: 20px; text-align: right;">
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </div>
    <add-or-edit-form :visible.sync="modalVisible" :show-type="modalShowType" :detailData="modalDetailData" @get-operation-result="getTableData"></add-or-edit-form>
  </page-container>
</template>
<script>
import moment from 'moment'
import pagination from '@/mixins/pagination'
import {getItemFromArrayByKey} from "U/index";
import addOrEditForm from "V/backlogs/maintainmanage/abarbeitung/addOrEditForm";
import {findAbarbeitungByCondition} from "A/wbgl";
export default {
  name: 'elevatorArchives',
  mixins: [pagination],
  components: {
    addOrEditForm,
  },
  props: ['pageType'],
  data() {
    return {
      moment,
      showAdvanced: false,
      queryParams: {
        initiator:'',
        acceptor:'',
        depwaitrect:'',
        liftwaitrect:'',
        rectdetail:'',
        recttime:'',
        isreply:'',
      },
      tableColumns: [
        {
          title: '发起人',
          dataIndex: 'initiator',
          key: 'initiator',
          ellipsis: true,
        },
        {
          title: '受理人',
          dataIndex: 'acceptor',
          key: 'acceptor',
          ellipsis: true,
        },
        {
          title: '待整改单位',
          dataIndex: 'depwaitrect',
          key: 'depwaitrect',
          ellipsis: true,
        },
        {
          title: '待整改电梯',
          dataIndex: 'liftwaitrect',
          key: 'liftwaitrect',
          ellipsis: true,
        },
        {
          title: '整改时限',
          dataIndex: 'recttime',
          key: 'recttime',
          ellipsis: true,
          scopedSlots: { customRender: 'recttime' }
        },
        {
          title: '是否回复',
          dataIndex: 'isreply',
          key: 'isreply',
          ellipsis: true,
          scopedSlots: { customRender: 'isreply' }
        },
        {
          title: '整改结果',
          dataIndex: 'approved',
          key: 'approved',
          ellipsis: true,
          scopedSlots: { customRender: 'approved' }
        },
        {
          title: '操作',
          key: 'operation',
          align: 'center',
          width: 70,
          scopedSlots: { customRender: 'operation' }
        },
      ],
      tableData: [],
      tableLoading: false,
      modalVisible: false,
      modalShowType: '',
      modalDetailData: null,
      pageTitle:'问题整改',
      counts:'',
    }
  },
  computed: {
    breadcrumb() {
      return [
        {
          name: '我的待办',
          path: ''
        },
        {
          name: '按需维保管理',
          path: ''
        },
        {
          name: '问题整改',
          path: ''
        },
      ]
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getTableData();
    },
    resetQueryParams() {
      this.$refs.queryForm.resetFields();
      this.$refs.advancedForm.resetFields();
    },
    getTableData(firstPage) {
      if(firstPage) {
        this.currentPage = 1;
      }
      this.tableLoading = true;
      let params = {
        ...this.queryParams,
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize
      };
      // if(params.depwaitrect==''&&params.liftwaitrect==''&&params.initiator==''&&params.acceptor==''){
      //   findAbarbeitungByCondition(params).then(res => {
      //     this.tableLoading = false;
      //     if (res && res.returncode == '0') {
      //       this.tableData = res.item;
      //       this.counts = res.count;
      //     }
      //   }).catch(err => {
      //     this.tableLoading = false;
      //   })
      // }
      findAbarbeitungByCondition(params).then(res => {
        this.tableLoading = false;
        if (res && res.returncode == '0') {
          this.tableData = res.item;
          this.pagination.total = res.count;
        }
      }).catch(err => {
        this.tableLoading = false;
      })
    },
    showModal(){
      this.modalVisible=true
    },
    deleteConfirm(value, record) {
      this.$confirm({
        content: '确定要删除该数据?',
        okText: '确定',
        cancelText: '取消',
        onOk:() => {
          this.delete(record.abarbeitungid);
        },
        onCancel() {},
      });
    },
    delete() {
      this.showLoading();
    },
    operationClick({key}) {
      let arr = key.split('-');
      let type = arr[0];
      let abarbeitungid = arr[1];
      let record = getItemFromArrayByKey(this.tableData, 'abarbeitungid', abarbeitungid);
      if(type == 'detail') {
        this.showModal('detail', abarbeitungid, record)
      } else if(type == 'edit') {
        this.showModal('edit', abarbeitungid, record)
      }else {
      }
    },
  }
}
</script>
<style lang="scss" scoped>
</style>